__turbopack_context__.v({
  "carousel": "HubDestinationRegions-module__LdKZEW__carousel",
  "findDestination": "HubDestinationRegions-module__LdKZEW__findDestination",
  "findDestinationText": "HubDestinationRegions-module__LdKZEW__findDestinationText",
  "scroller": "HubDestinationRegions-module__LdKZEW__scroller",
  "slide": "HubDestinationRegions-module__LdKZEW__slide",
  "title": "HubDestinationRegions-module__LdKZEW__title",
});
